import React from 'react';
import styles from './title.module.css';
import Icon from "../icons/icons";


const Title = props => {
  return (
    <div className={styles.title}>
      <Icon name={props.icon} viewbox="0 0 64 64" />
      <span className={styles.title_name}>{props.title}</span>
    </div>
  )
}

export default Title;